import { useMemo } from "react";
import { useTable } from "react-table";
import {
  defaultDateDisplay,
  extractReadableDateOnly,
  formatCurrency,
} from "../../../helpers";
import primaryComponents from "../../primaryComponents";
import { pathConstants } from "../../../routes/pathContants";
import { useNavigate } from "react-router-dom";

const useVatInflowsTable = ({ vatInflowData, selectedTab }) => {
  const navigate = useNavigate();
  const columns = useMemo(
    () => [
      {
        Header: "VAT Entry Date",
        accessor: "vat_period",
        Cell: ({ cell: { value } }) => (
          <span>{extractReadableDateOnly(value)}</span>
        ),
      },
      {
        Header: "VAT Amount Paid",
        accessor: "amount",
        Cell: ({ cell: { value }, row }) => (
          <span
            style={{
              color: value < 0 ? "#E02020" : "#27AE60",
              fontWeight: 500,
            }}
          >
            {formatCurrency({
              value: value,
              currencyCode: row?.original?.store?.currency_code,
            })}
          </span>
        ),
      },
      {
        Header: "Total Amount Paid",
        accessor: "total_amount",
        Cell: ({ cell: { value }, row }) => (
          <span>
            {formatCurrency({
              value: value,
              currencyCode: row?.original?.store?.currency_code,
            })}
          </span>
        ),
      },
      {
        Header: "Net Amount",
        accessor: "net_amount",
        Cell: ({ cell: { value }, row }) => (
          <span>
            {formatCurrency({
              value: value,
              currencyCode: row?.original?.store?.currency_code,
            })}
          </span>
        ),
      },
      {
        Header: "Store",
        accessor: "store",
        Cell: ({ cell: { value } }) => <span>{value?.name || "N/A"}</span>,
      },
      {
        Header: "Source",
        accessor: "source",
        Cell: ({ cell: { value } }) => (
          <span>
            {value?.charAt(0)?.toUpperCase() + value?.slice(1)?.toLowerCase()}
          </span>
        ),
      },
      {
        Header: "Category",
        accessor: "source_description",
        Cell: ({ cell: { value } }) => <span>{value}</span>,
      },
      {
        Header: "VAT Charged?",
        accessor: "is_charged",
        Cell: ({ cell: { value } }) => <span>{value ? "Yes" : "No"}</span>,
      },
      {
        Header: "Created On",
        accessor: "created_at",
        Cell: ({ cell: { value } }) => <span>{defaultDateDisplay(value)}</span>,
      },
      {
        Header: "Description",
        accessor: "description",
        Cell: ({ cell: { value }, row }) => <span>{value}</span>,
      },
      {
        Header: "VAT Recoverable?",
        accessor: "is_recoverable",
        Cell: ({ cell: { value } }) => <span>{value ? "Yes" : "No"}</span>,
      },
      {
        Header: "Action",
        accessor: "reference",
        Cell: ({ cell: { value }, row }) => (
          <span>
            {row?.original?.entity_type === "EXPENSE" && (
              <primaryComponents.Button
                className="btn btn--primary smallBtn"
                onClick={() => {
                  navigate(
                    pathConstants.EXPENSES_DETAILS({
                      id: value,
                    }),
                  );
                }}
              >
                View
              </primaryComponents.Button>
            )}
            {row?.original?.entity_type === "GOODS_RECEIVED" && (
              <primaryComponents.Button
                className="btn btn--primary smallBtn"
                onClick={() => {
                  navigate(
                    pathConstants.INVENTORY_GOODS_RECEIVED_DETAILS({
                      id: value,
                    }),
                  );
                }}
              >
                View
              </primaryComponents.Button>
            )}
          </span>
        ),
      },
    ],
    [selectedTab],
  );

  const instance = useTable({
    columns: columns,
    data: vatInflowData,
  });

  return {
    instance,
  };
};

export default useVatInflowsTable;
